import { useMemo } from "react";
import {
  Heading5,
  Icon,
  ImageLite,
  PageLink,
  Paragraph,
} from "shared/components";
import { truncateText } from "shared/utils";

import styles from "./Item.module.scss";

const DEFAULT_VISIBLE_LETTERS = 150;

export const Item = ({ item }) => {
  const truncatedDescription = useMemo(() => {
    return truncateText(item.description, DEFAULT_VISIBLE_LETTERS);
  }, [item.description]);

  return (
    <PageLink directory="projects" slug={item?.slug} className={styles.wrapper}>
      <div className={styles.block}>
        <ImageLite image={item.previewImage} className={styles.image} />
        <div className={styles.title}>
          <Heading5 color="light" appearance="bold">
            {item.title}
          </Heading5>
          <span className={styles.arrow}>
            <Icon className={styles.icon} name="arrow_right" />
          </span>
        </div>
        <Paragraph color="light" className={styles.description}>
          {truncatedDescription}
        </Paragraph>
      </div>
    </PageLink>
  );
};
